import { NewsItem } from "styles/jss/Home.styles";
import NextImage from "../../NextImage";
import DateStamp from "../../DateStamp";
import Link from "next/link";
import { useRouter } from "next/router";
import { getImageUrl } from "../../../utils/helperFunction";

export default function NewsItemBox({ height, width, typeSize, ...data }) {
  const { locale } = useRouter();
  const {
    id,
    attributes: { slug, thumbnail, title, datetime },
  } = data;

  return (
    <Link href={`media-center/news/${id}/${slug}`} locale={locale}>
      <a>
        <NewsItem type={typeSize} height={height} width={width}>
          <div className={"imageWrapper"}>
            <NextImage
              src={
                getImageUrl(thumbnail.data?.attributes.formats, [
                  "large",
                  "medium",
                ])?.url
              }
              alt={title}
              layout={"fill"}
              objectFit={"cover"}
              placeholder="blur"
            />
          </div>
          <div className={"content"}>
            <p>{title}</p>
            <DateStamp date={datetime} />
          </div>
        </NewsItem>
      </a>
    </Link>
  );
}
